<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      width="1000px"
      top="10vh"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.batchAddForm.cancel()"
      v-el-dialog-drag
    >
      <BatchAdd
        ref="batchAddForm"
        :disabled="disabled"
        :orderCode="orderCode"
        @close="$emit('close')"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.batchAddForm.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!disabled"
          @click="$refs.batchAddForm.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import BatchAdd from './batch-add.vue'
export default {
  components: { BatchAdd },
  props: {
    disabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  overflow: hidden !important;
}
</style>

<style lang="scss">
.feedback-dialog {
  position: absolute !important;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0 auto !important;
  margin-top: 0 !important;
}
</style>
